"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var variable_parsed_text_styles_1 = require("./variable-parsed-text.styles");

var variable_value_component_1 = __importDefault(require("../variable-value/variable-value.component"));

var VariableParsedParagraph = function VariableParsedParagraph(_ref) {
  var rawText = _ref.rawText,
      variables = _ref.variables,
      onClick = _ref.onClick;
  var texts = rawText.split(/\$\{([^${}\s]+)\}/);
  return react_1.default.createElement(variable_parsed_text_styles_1.StyledTextWrapperDiv, {
    onClick: onClick,
    clickable: !!onClick,
    "data-meta": "variable-parsed-paragraph"
  }, texts.map(function (text, i) {
    var variable = variables.find(function (v) {
      return v.key === text;
    });
    if (!variable) return react_1.default.createElement(variable_parsed_text_styles_1.StyledTextSpan, {
      key: i
    }, text);
    return react_1.default.createElement(variable_value_component_1.default, {
      key: i,
      variable: variable
    });
  }));
};

exports.default = VariableParsedParagraph;